import Users from '@/views/configuration/dictionnaire/user/pages/User';
import Create from '@/views/configuration/dictionnaire/user/pages/UserCreate';
import Edit from '@/views/configuration/dictionnaire/user/pages/UserEdit';
import Show from '@/views/configuration/dictionnaire/user/pages/UserShow';

export default [
  {
    path: '/parametre/user',
    name: 'parametre_user',
    component: Users,
    meta: {
      Auth: true,
      permission: 'access setting',
    },
  },
  {
    path: '/parametre/user/create',
    name: 'parametre_user-create',
    component: Create,
    meta: {
      Auth: true,
      permission: 'access setting',
    },
  },
  {
    path: '/parametre/user/edit/:id',
    name: 'parametre_user-edit',
    component: Edit,
    meta: {
      Auth: true,
      permission: 'access setting',
    },
  },
  {
    path: '/parametre/user/show/:id',
    name: 'parametre_user-show',
    component: Show,
    meta: {
      Auth: true,
      permission: 'access setting',
    },
  },
];
